import { Route, Routes } from "react-router-dom";
import PrivateRoute from "./PrivateRoute";
import PageNotFound from "../pages/ErrorPage/PageNotFound";
import DashboardLayout from "../layouts/DashboardLayout";
import Dashboard from "../pages/Dashboard";
import WareHouseList from "../pages/WareHouse/WareHouseList";
import { OrderList } from "../pages/Order/OrderList";
import CustomerList from "../pages/Customer/CustomerList";
import StaffList from "../pages/Staff/StaffList";
import MerchantList from "../pages/Merchant/MerchantList";
import RiderList from "../pages/Rider/RiderList";
import Settings from "../pages/Settings";
import { Overview } from "../pages/Finance/Overview";
import StateList from "../pages/State/StateList";
import DistrictList from "../pages/District/DistrictList";
import ProductTypeList from "../pages/ProductType/ProductTypeList";
import CountryList from "../pages/Country/CountryList";
import CityList from "../pages/City/CityList";
import BranchList from "../pages/Branch/BranchList";
import StatusList from "../pages/Status/StatusList";
import CreateBranch from "../pages/Branch/CreateBranch";
import CreateState from "../pages/State/CreateState";
import CreateCity from "../pages/City/CreateCity";
import CreateCountry from "../pages/Country/CreateCountry";
import CreateProductType from "../pages/ProductType/CreateProductType";
import CreateDistrict from "../pages/District/CreateDistrict";
import CreateStatus from "../pages/Status/CreateStatus";
import CreateWarehouse from "../pages/WareHouse/CreateWarehouse";
import CreateOrder from "../pages/Order/CreateOrder";
import CreateCustomer from "../pages/Customer/CreateCustomer";
import CreateMerchant from "../pages/Merchant/CreateMerchant";
import CreateRider from "../pages/Rider/CreateRider";
import CreateStaff from "../pages/Staff/CreateStaff";
import EditStatus from "../pages/Status/EditStatus";
import EditWarehouse from "../pages/WareHouse/EditWarehouse";
import EditOrder from "../pages/Order/EditOrder";
import EditCustomer from "../pages/Customer/EditCustomer";
import EditStaff from "../pages/Staff/EditStaff";
import EditMerchant from "../pages/Merchant/EditMerchant";
import EditRider from "../pages/Rider/EditRider";
import EditDistrict from "../pages/District/EditDistrict";
import EditProductType from "../pages/ProductType/EditProductType";
import EditCountry from "../pages/Country/EditCountry";
import EditCity from "../pages/City/EditCity";
import EditState from "../pages/State/EditState";
import EditBranch from "../pages/Branch/EditBranch";
import DeliveryChargeList from "../pages/DeliveryCharge/DeliveryChargeList";
import CreateDeliveryCharge from "../pages/DeliveryCharge/CreateDeliveryCharge";
import EditDeliveryCharge from "../pages/DeliveryCharge/EditDeliveryCharge";
import OrderBulkUpload from "../pages/Order/OrderBulkUpload";
import Invoice from "../pages/Finance/Invoice";
import CreateInvoice from "../pages/Finance/CreateInvoice";
import InvoicePreview from "../pages/Finance/InvoicePreview";
import DeliveryChargeTemplateList from "../pages/DeliveryChargeTemplate/DeliveryChargeListTemplate";
import CreateDeliveryChargeTemplate from "../pages/DeliveryChargeTemplate/CreateDeliveryChargeTemplate";
import EditDeliveryChargeTemplate from "../pages/DeliveryChargeTemplate/EditDeliveryChargeTemplate";
import useGetHook from "../customHooks/useGetHook";
import APIS from "../constant/EndPoint";
import TicketList from "../pages/Ticket/TicketList";
import CreateTicket from "../pages/Ticket/CreateTicket";
import RiderKMRecord from "../pages/RiderKMRecord/RiderKMRecord";
import NotificationList from "../pages/Notification/NotificationList";
import UserProfile from "../pages/Auth/UserProfile";
import RoleList from "../pages/Auth/RoleList";
import UserList from "../pages/Auth/UserList";
import CreateRole from "../pages/Auth/CreateRole";
import UpdateRole from "../pages/Auth/UpdateRole";
import CreateUser from "../pages/Auth/CreateUser";
import UpdateUser from "../pages/Auth/UpdateUser";
import ReferenceTypeList from "../pages/Settings/ReferenceType/ReferenceTypeList";
import EditReferenceType from "../pages/Settings/ReferenceType/EditReferenceType";
import PaymentMethodList from "../pages/Settings/PaymentMethod/PaymentMethodList";
import EditPaymentMethod from "../pages/Settings/PaymentMethod/EditPaymentMethod";
import ServiceTypeList from "../pages/Settings/ServiceType/ServiceTypeList";
import EditServiceType from "../pages/Settings/ServiceType/EditServiceType";
import CreateServiceType from "../pages/Settings/ServiceType/CreateServiceType";
import CreatePaymentMethod from "../pages/Settings/PaymentMethod/CreatePaymentMethod";
import CreateReferenceType from "../pages/Settings/ReferenceType/CreateReferenceType";
import ManifestList from "../pages/Manifest/ManifestList";
import VehicleCategoryList from "../pages/Settings/VehicleCategory/VehicleCategoryList";
import CreateVehicle from "../pages/Settings/Vehicle/CreateVehicle";
import VehicleList from "../pages/Settings/Vehicle/VehicleList";
import EditVehicle from "../pages/Settings/Vehicle/EditVehicle";
import CreateVehicleCategory from "../pages/Settings/VehicleCategory/CreateVehicleCategory";
import EditVehicleCategory from "../pages/Settings/VehicleCategory/EditVehicleCategory";
import CreateVehicleType from "../pages/Settings/VehicleType/CreateVehicle";
import VehicleTypeList from "../pages/Settings/VehicleType/VehicleList";
import EditVehicleType from "../pages/Settings/VehicleType/EditVehicle";
import CreateManifest from "../pages/Manifest/CreateManifest";
import EditManifest from "../pages/Manifest/EditManifest";

// import AccessControl from "../helpers/accessControl";
// import PermissionDenied from "../pages/Error/PermissionDenied";

// https://adarshaacharya.com.np/blog/role-based-auth-with-react-router-v6

/**
 * Top level application router
 *
 * @returns {JSX.Element}
 */
const Router = () => {
  const { data: userProfileType } = useGetHook({
    queryKey: [`user-profile`],
    url: `${APIS.USER_PROFILE}`,
    params: {},
  });

  return (
    <Routes>
      <Route
        element={
          <PrivateRoute>
            <DashboardLayout />
          </PrivateRoute>
        }
      >
        <Route path={"/"} element={<Dashboard />} />

        {userProfileType?.is_staff ? <>
          <Route path={"/warehouse"} element={<WareHouseList />} />
          <Route path={"/warehouse/edit/:id"} element={<EditWarehouse />} />
          <Route path={"/create-warehouse"} element={<CreateWarehouse />} />
          <Route path={"/order/:id?"} element={<OrderList />} />
          <Route path={"/order/bulk-upload"} element={<OrderBulkUpload />} />
          <Route path={"/order/edit/:id"} element={<EditOrder />} />
          <Route path={"/create-order"} element={<CreateOrder />} />
          <Route path={"/customer"} element={<CustomerList />} />
          <Route path={"/customer/edit/:id"} element={<EditCustomer />} />
          <Route path={"/customer/create"} element={<CreateCustomer />} />
          <Route path={"/staff"} element={<StaffList />} />
          <Route path={"/staff/edit/:id"} element={<EditStaff />} />
          <Route path={"/staff/create"} element={<CreateStaff />} />
          <Route path={"/merchant"} element={<MerchantList />} />
          <Route path={"/merchant/edit/:id"} element={<EditMerchant />} />
          <Route path={"/merchant/create"} element={<CreateMerchant />} />
          <Route path={"/rider"} element={<RiderList />} />
          <Route path={"/rider/edit/:id"} element={<EditRider />} />
          <Route path={"/rider/create"} element={<CreateRider />} />
          <Route path={"/settings"} element={<Settings />} />
          <Route path={"/finance-overview"} element={<Overview />} />
          <Route path={"/status-settings"} element={<StatusList />} />
          <Route path={"/status-settings/edit/:id"} element={<EditStatus />} />
          <Route path={"/create-status"} element={<CreateStatus />} />
          <Route path={"/district"} element={<DistrictList />} />
          <Route path={"/district/edit/:id"} element={<EditDistrict />} />
          <Route path={"/create-district"} element={<CreateDistrict />} />
          <Route path={"/product-type"} element={<ProductTypeList />} />
          <Route path={"/product-type/edit/:id"} element={<EditProductType />} />
          <Route path={"/create-product-type"} element={<CreateProductType />} />
          <Route path={"/country"} element={<CountryList />} />
          <Route path={"/country/edit/:id"} element={<EditCountry />} />
          <Route path={"/create-country"} element={<CreateCountry />} />
          <Route path={"/city"} element={<CityList />} />
          <Route path={"/city/edit/:id"} element={<EditCity />} />
          <Route path={"/create-city"} element={<CreateCity />} />
          <Route path={"/state"} element={<StateList />} />
          <Route path={"/state/edit/:id"} element={<EditState />} />
          <Route path={"/create-state"} element={<CreateState />} />
          <Route path={"/branch"} element={<BranchList />} />
          <Route path={"/branch/edit/:id"} element={<EditBranch />} />
          <Route path={"/create-branch"} element={<CreateBranch />} />

          <Route path={"/delivery-charge/:templateID?"} element={<DeliveryChargeList />} />
          <Route path={"/create-delivery-charge/:templateID"} element={<CreateDeliveryCharge />} />
          <Route path={"/delivery-charge/:templateID/edit/:id"} element={<EditDeliveryCharge />} />

          <Route path={"/delivery-charge-template"} element={<DeliveryChargeTemplateList />} />
          <Route path={"/create-delivery-charge-template"} element={<CreateDeliveryChargeTemplate />} />
          <Route path={"/delivery-charge-template/edit/:id"} element={<EditDeliveryChargeTemplate />} />
          <Route path={"/invoice"} element={<Invoice />} />
          <Route path={"/invoice/preview/:id"} element={<InvoicePreview />} />
          <Route path={"/create-invoice"} element={<CreateInvoice />} />
          <Route path={"/ticket"} element={<TicketList />} />
          <Route path={"/km-record"} element={<RiderKMRecord />} />
          <Route path={"/users"} element={<UserList />} />
          <Route path={"/create-user"} element={<CreateUser />} />
          <Route path={"/users/edit/:id"} element={<UpdateUser />} />
          <Route path={"/roles"} element={<RoleList />} />
          <Route path={"/role-create"} element={<CreateRole />} />
          <Route path={"/roles/edit/:id"} element={<UpdateRole />} />
          <Route path={"/create-reference-type"} element={<CreateReferenceType />} />
          <Route path={"/reference-type"} element={<ReferenceTypeList />} />
          <Route path={"/reference-type/edit/:id"} element={<EditReferenceType />} />
          <Route path={"/create-payment-method"} element={<CreatePaymentMethod />} />
          <Route path={"/payment-method"} element={<PaymentMethodList />} />
          <Route path={"/payment-method/edit/:id"} element={<EditPaymentMethod />} />
          <Route path={"/create-service-type"} element={<CreateServiceType />} />
          <Route path={"/service-type"} element={<ServiceTypeList />} />
          <Route path={"/service-type/edit/:id"} element={<EditServiceType />} />
          <Route path={"/create-vehicle"} element={<CreateVehicle />} />
          <Route path={"/vehicle"} element={<VehicleList />} />
          <Route path={"/vehicle/edit/:id"} element={<EditVehicle />} />
          <Route path={"/create-vehicle-category"} element={<CreateVehicleCategory />} />
          <Route path={"/vehicle-category"} element={<VehicleCategoryList />} />
          <Route path={"/vehicle-category/edit/:id"} element={<EditVehicleCategory />} />
          <Route path={"/create-vehicle-type"} element={<CreateVehicleType />} />
          <Route path={"/vehicle-type"} element={<VehicleTypeList />} />
          <Route path={"/vehicle-type/edit/:id"} element={<EditVehicleType />} />
          <Route path={"/manifest"} element={<ManifestList />} />
          <Route path={"/manifest/edit/:id"} element={<EditManifest />} />
          <Route path={"/create-manifest"} element={<CreateManifest />} />

        </> : userProfileType?.is_rider ? <>
          <Route path={"/invoice"} element={<Invoice />} />
        </> : userProfileType?.is_merchant ? <>
          <Route path={"/order/bulk-upload"} element={<OrderBulkUpload />} />
          <Route path={"/create-order"} element={<CreateOrder />} />
          <Route path={"/invoice"} element={<Invoice />} />
          <Route path={"/branch"} element={<BranchList />} />
          <Route path={"/invoice/preview/:id"} element={<InvoicePreview />} />
          <Route path={"/delivery-charge/:templateID?"} element={<DeliveryChargeList />} />
          <Route path={"/ticket"} element={<TicketList />} />
          <Route path={"/create-ticket"} element={<CreateTicket />} />
        </> : <></>}
        <Route path={"/profile"} element={<UserProfile />} />
        <Route path={"/notification"} element={<NotificationList />} />
        <Route path="/*" element={<PageNotFound />} />
      </Route>
    </Routes>
  );
};

export default Router;
